import React, { FC } from 'react';
import Link from 'components/AppSafeLink/AppSafeLink';
import '/public/css/components/forYouSubNav.css';
import IconSettings from 'components/Icons/IconSettings';

interface Props {
  current?: 'for-you' | 'stories';
}

const ForYouSubNav: FC<Props> = ({ current = 'for-you' }) => {
  return (
    <div className="for-you-subnav-container">
      <div className="for-you-subnav-layout">
        <ul className="for-you-subnav">
          <li>
            <Link
              href="/for-you/"
              className={`type-lg ${current === 'for-you' ? 'current' : ''}`}
            >
              Your Feed
            </Link>
          </li>
          <li>
            <Link
              href="/for-you/stories"
              className={`type-lg ${current === 'stories' ? 'current' : ''}`}
            >
              Saved Stories
            </Link>
          </li>
        </ul>
        <button className="btn for-you-category-btn">
          <IconSettings title="" className="stroke-icon" />
          <Link href="/for-you/following">Categories You Follow</Link>
        </button>
      </div>
      <h1>
        Welcome to MPR News <span>For You</span>
      </h1>
    </div>
  );
};

export default ForYouSubNav;
